
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Search from '../search/Search.vue';
import DocButton from '@/components/ui/buttons/DocButton.vue';
import SearchInput from '@/components/docs-main/search/SearchInput.vue';
import LocaleSelector from '@/components/ui/LocaleSelector.vue';
import { currentInstance } from '@/heplers';

@Component({
  components: {
    Search,
    SearchInput,
    DocButton,
    LocaleSelector,
  },
})
export default class NavbarHeader extends Vue {
  get getSignUpLink() {
    return currentInstance === 'kit'
      ? 'https://kit.voximplant.com/registration'
      : 'https://manage.voximplant.com/auth/sign_up';
  }

  get currentInstance() {
    return currentInstance;
  }

  get getLogInLink() {
    return currentInstance === 'kit'
      ? 'https://kit.voximplant.com/login'
      : 'https://manage.voximplant.com/auth/';
  }

  get getHelpLink() {
    return currentInstance === 'kit' ? '/kit/docs/gettingstarted/gettingstarted' : '/help/faq';
  }

  get getStackOverflowLink() {
    return currentInstance === 'kit'
      ? 'https://stackoverflow.com/search?q=voximplant'
      : 'https://stackoverflow.com/search?q=voximplant';
  }

  sendGtmLogin() {
    this.$sendGtmEvent({
      event: 'vox_docs_to_login',
      category: 'main_docs',
      action: 'login',
    });
  }

  sendGtmSignup() {
    this.$sendGtmEvent({
      event: 'vox_docs_to_signup',
      category: 'main_docs',
      action: 'signup',
    });
  }

  sendGtmHelp() {
    this.$sendGtmEvent({
      event: 'vox_docs_help_go',
      category: 'help',
      action: 'go_help',
      label: this.$router.currentRoute.path,
    });
  }
}
